import { render, staticRenderFns } from "./indexNotice.vue?vue&type=template&id=63fbd018&scoped=true"
import script from "./indexNotice.vue?vue&type=script&lang=js"
export * from "./indexNotice.vue?vue&type=script&lang=js"
import style0 from "./indexNotice.vue?vue&type=style&index=0&id=63fbd018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbd018",
  null
  
)

export default component.exports